<template>
    <modal @close="$emit('close')" ref="modal">
        <template v-slot:title>Add GetMyPayStub Client</template>

        <p>
            Create new <b>GetMyPayStub-only</b> client
        </p>

        <slot>
            <form-errors :errors="formErrors"/>

            <div class="form-row pb-2">
                <div class="col">
                    <form-input label="Client Name" type="text" :maxlength="50" v-model="formData.name" :errors="errors.name" />
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Create</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    mixins: [FormMixin, ModalMixin],
    props: [],
    data() {
        return {
            formData: {
                name: null,
            },
            formRules: {
                name: {presence: {allowEmpty: false}, },
            },
        }
    },
    methods: {
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            let url = `/admin/clients/new-client`
            api.post(url, this.formData).then((resp) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully created ${this.formData.name}`)

                console.log(resp)

                let hashedClientId = this.$hasher.encode(resp.id)
                this.$router.push({name: 'client-setup-services', params: {hashedClientId: hashedClientId}})

                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
                this.$store.dispatch('STOP_LOADING')
            })
        },
    }
}
</script>
